import script from "./PatientBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientBar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__